var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("售后工单商品-列表")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "form",
                            attrs: { model: _vm.form, "label-width": "85px" }
                          },
                          [
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "输入搜索：" } },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 2 } },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "工单ID" },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.work_id,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "work_id",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.work_id"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 2 } },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "订单号" },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.order_sn,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "order_sn",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.order_sn"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "运单号" },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.tracking_sn,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "tracking_sn",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.tracking_sn"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 2 } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "商品货号"
                                              },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.goods_sn,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "goods_sn",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.goods_sn"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "商品名称"
                                              },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.goods_name,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "goods_name",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.goods_name"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 2 } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "最后处理人"
                                              },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.update_admin,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "update_admin",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.update_admin"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _vm.resData
                                              ? _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      placeholder:
                                                        "选择政策类型"
                                                    },
                                                    model: {
                                                      value: _vm.form.policy,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "policy",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "form.policy"
                                                    }
                                                  },
                                                  [
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "全部",
                                                        value: ""
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.resData.optionsPolicy,
                                                      function(item) {
                                                        return _c("el-option", {
                                                          key: item.key,
                                                          attrs: {
                                                            label: item.label,
                                                            value: item.key
                                                          }
                                                        })
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _vm.resData
                                              ? _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      placeholder:
                                                        "用户退款状态"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.refund_status,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "refund_status",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.refund_status"
                                                    }
                                                  },
                                                  [
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "全部",
                                                        value: ""
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.resData.optionsRefund,
                                                      function(item) {
                                                        return _c("el-option", {
                                                          key: item.key,
                                                          attrs: {
                                                            label: item.label,
                                                            value: item.key
                                                          }
                                                        })
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _vm.resData
                                              ? _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      placeholder:
                                                        "换货处理状态"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.barter_status,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "barter_status",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.barter_status"
                                                    }
                                                  },
                                                  [
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "全部",
                                                        value: ""
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.resData.optionsBarter,
                                                      function(item) {
                                                        return _c("el-option", {
                                                          key: item.key,
                                                          attrs: {
                                                            label: item.label,
                                                            value: item.key
                                                          }
                                                        })
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 7 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "收件时间：" } },
                                      [
                                        _c("el-date-picker", {
                                          attrs: {
                                            type: "daterange",
                                            "range-separator": "至",
                                            "start-placeholder": "开始日期",
                                            "end-placeholder": "结束日期"
                                          },
                                          model: {
                                            value: _vm.form.receive_time,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "receive_time",
                                                $$v
                                              )
                                            },
                                            expression: "form.receive_time"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 7 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "寄件时间：" } },
                                      [
                                        _c("el-date-picker", {
                                          attrs: {
                                            type: "daterange",
                                            "range-separator": "至",
                                            "start-placeholder": "开始日期",
                                            "end-placeholder": "结束日期"
                                          },
                                          model: {
                                            value: _vm.form.delivery_time,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "delivery_time",
                                                $$v
                                              )
                                            },
                                            expression: "form.delivery_time"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 7 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          "label-width": "125px",
                                          label: "最后处理时间："
                                        }
                                      },
                                      [
                                        _c("el-date-picker", {
                                          attrs: {
                                            type: "daterange",
                                            "range-separator": "至",
                                            "start-placeholder": "开始日期",
                                            "end-placeholder": "结束日期"
                                          },
                                          model: {
                                            value: _vm.form.last_opera_time,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "last_opera_time",
                                                $$v
                                              )
                                            },
                                            expression: "form.last_opera_time"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 2 } },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.search }
                                      },
                                      [_vm._v("查询")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c("div", [_vm._v("数据列表：")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "auto" },
                    attrs: { type: "success", size: "mini" },
                    on: {
                      click: function($event) {
                        return _vm.output(1)
                      }
                    }
                  },
                  [_vm._v("面单导出")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "10px" },
                    attrs: { type: "success", size: "mini" },
                    on: {
                      click: function($event) {
                        return _vm.output(2)
                      }
                    }
                  },
                  [_vm._v("导出")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "margin-bottom": "0" } },
                  [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          height: "600",
                          data: _vm.resData.list,
                          "tooltip-effect": "dark"
                        },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "work_id",
                            label: "工单ID",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "policy_str",
                            label: "政策类型",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "handle_type_str",
                            label: "处理类型",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "order_sn",
                            label: "订单号",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "tracking_sn",
                            label: "运单号",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_no",
                            label: "商品货号",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { type: "expand", props: "goods_sn" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "el-form",
                                      {
                                        ref: "form",
                                        staticClass: "demo-form-inline",
                                        attrs: {
                                          inline: true,
                                          model: _vm.formInline,
                                          "label-width": "80px"
                                        }
                                      },
                                      [
                                        _c("el-form-item", [
                                          _c("img", {
                                            staticStyle: {
                                              width: "130px",
                                              height: "130px"
                                            },
                                            attrs: { src: props.row.goods_img }
                                          })
                                        ]),
                                        _vm._v(" "),
                                        _c("el-form-item", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(props.row.goods_name) +
                                              "\n                "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("el-form-item", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(props.row.color) +
                                              " / " +
                                              _vm._s(props.row.size) +
                                              " *\n                  " +
                                              _vm._s(props.row.quantity) +
                                              "\n                "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("el-form-item", [
                                          _c("span", [
                                            _vm._v(_vm._s(props.row.price))
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("el-form-item", [
                                          _c("span", [
                                            _vm._v(_vm._s(props.row.market))
                                          ])
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4198187485
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "create_admin",
                            label: "发布人",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "refund_status_str",
                            label: "用户退款状态",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "remark",
                            label: "售后退款备注",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "barter_status_str",
                            label: "换货处理状态",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "receive_time",
                            label: "收件时间",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "update_admin",
                            label: "最后处理人",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "last_opera_time",
                            label: "最后处理时间",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "delivery_time",
                            label: "寄出时间",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "delivery_tracking_sn",
                            label: "寄出运单号",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.curPage,
                        background: "",
                        layout: "total, prev, pager, next, jumper ",
                        total: _vm.resData.count,
                        "page-size": 10
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.curPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.curPage = $event
                        },
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a2481f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a2481f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AfterSalesList.vue
// module id = null
// module chunks = 